// moment-config.service.ts
import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable()
export class MomentConfigService {
  constructor() {
    this.configureMomentLocale();
  }

  private configureMomentLocale() {
    moment.locale('fr-FR'); // Définit la localisation française
  }
}
